/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'user': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: '<path pid="0" d="M22 5.5a7.333 7.333 0 100 14.666A7.333 7.333 0 0022 5.5zm0 20.167c-5.507 0-16.5 2.764-16.5 8.25v2.75c0 1.012.821 1.833 1.833 1.833h29.334a1.834 1.834 0 001.833-1.833v-2.75c0-5.486-10.993-8.25-16.5-8.25z" _fill="#fff"/>'
  }
})
